'use es6';

import tinymce from 'tinymce';
import ReactDOM from 'react-dom';
import EmbedModal from 'rich-text-lib/components/EmbedModalV2';
import { path } from 'rich-text-lib/utils/iterables';
import { appendDivToEditor } from '../utils';
import { initPlugin, getPropsForEmbedModal, onInsertIframeEmbed, getFetchEmbedCode } from './shared';
import { __HS_MEDIA } from '../constants/plugins';
import { getMceRootNode } from '../utils/namespace';
import { AppProvider } from 'foundations-components/components/AppProvider';
import { RTEContextProvider } from 'foundations-components/transitional/context';
import { jsx as _jsx } from "react/jsx-runtime";
export const HS_MEDIA = __HS_MEDIA;
let modalDomNode = null;
export const getOpenEmbedModal = editor => {
  const apiClient = editor.getParam('apiClient');
  const {
    getUserAttributes,
    setUserAttribute
  } = path(['plugins', 'hscore', 'api'], editor);
  return () => {
    const {
      embed
    } = getPropsForEmbedModal(editor);
    if (!modalDomNode) {
      const container = appendDivToEditor(editor, 'embed-modal-container');
      if (!container) {
        console.error('Could not append div to editor.');
        return;
      }
      modalDomNode = container;
    }
    const submitHandler = modalData => {
      onInsertIframeEmbed(editor, modalData);
    };
    const handleClose = () => {
      ReactDOM.unmountComponentAtNode(modalDomNode);
    };
    ReactDOM.render( /*#__PURE__*/_jsx(AppProvider, {
      children: /*#__PURE__*/_jsx(RTEContextProvider, {
        children: /*#__PURE__*/_jsx(EmbedModal, {
          rootNode: getMceRootNode(),
          embed: embed,
          onSubmit: submitHandler,
          onClose: handleClose,
          fetchEmbedCode: getFetchEmbedCode(apiClient),
          getUserAttributes: getUserAttributes,
          setUserAttribute: setUserAttribute,
          useIframeEmbeds: true
        })
      })
    }), modalDomNode);
    editor.on('remove', () => {
      ReactDOM.unmountComponentAtNode(modalDomNode);
    });
  };
};
function hsmediaPlugin(editor) {
  initPlugin(editor, HS_MEDIA, getOpenEmbedModal(editor));
}
tinymce.PluginManager.add(HS_MEDIA, hsmediaPlugin);